const various = {
  sidebarOpen: 'explore more',
  sidebarClose: '',
  videoClose: '',
  compare: 'Confronta',
}

export default various
